// extracted by mini-css-extract-plugin
export default {"container":"_3h7Kq","box":"_1Bm6I","title":"_2uQte","subtitle":"_287rV","button":"_1QBOb"};